<template>
  <div class="check-detail">
    <div id="printArea" :style="{ width: printWidth + 'mm' }">
      <h2 class="title">新能源营运车辆日常安全检查单</h2>

      <div class="info-table">
        <table>
          <tr>
            <td width="15%">车牌号</td>
            <td width="20%">{{ mainBill.vehicleNo }}</td>
            <td width="24%">车型品牌</td>
            <td width="20%">{{ mainBill.brand }}</td>
            <td width="10%">车辆颜色</td>
            <td width="15%">{{ mainBill.color }}</td>
          </tr>
          <tr>
            <td>驾驶司机</td>
            <td>{{ mainBill.driverName }}</td>
            <td>司机是否确认</td>
            <td>是</td>
            <td>检查日期</td>
            <td>{{ (mainBill.arriveDate || mainBill.billDate) | dateFormat("yyyy-MM-dd") }}</td>
          </tr>
          <tr>
            <td>检查项目</td>
            <td colspan="5" class="content-cell">检查结果</td>
          </tr>
          <tr v-for="(item, index) in displayItems" :key="`${item.itemName || 'item'}-${index}`">
            <td>{{ item.itemName || "未命名项目" }}</td>
            <td colspan="5" class="content-cell">{{ formatItemContent(item) }}</td>
          </tr>
          <tr v-if="hasTirePhotos">
            <td>轮胎照片</td>
            <td colspan="5" class="content-cell photo-cell">
              <div class="photo-area tire-photo-area">
                <div class="tire-position-grid">
                  <div v-for="position in tirePhotoPositions" :key="position.key" class="tire-position-item">
                    <div class="position-title">{{ position.label }}</div>
                    <div class="photo-list">
                      <div v-for="(img, index) in tirePhotoMap[position.key]" :key="`${position.key}-${index}`"
                        class="photo-item">
                        <img :src="img" :alt="`${position.label}轮胎照片`" />
                      </div>
                      <div v-if="!tirePhotoMap[position.key] || !tirePhotoMap[position.key].length" class="empty-photo">
                        暂无照片
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>车辆照片</td>
            <td colspan="5" class="content-cell photo-cell">
              <div class="photo-area">
                <div class="photo-list">
                  <div v-for="(img, index) in checkImgs" :key="index" class="photo-item">
                    <img :src="img" alt="车辆照片" />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>检查备注</td>
            <td colspan="5" class="content-cell">{{ checkRemark }}</td>
          </tr>
          <tr>
            <td>检查单位</td>
            <td>{{ mainBill.providerName }}</td>
            <td>当前里程数</td>
            <td>{{ totalMilesText }}</td>
            <td>检查人员</td>
            <td>{{ mainBill.staffName }}</td>
          </tr>
          <tr>
            <td>检查人员签名</td>
            <td colspan="5" class="content-cell">
              <img :src="mainBill.staffSign" width="60px" height="auto" />
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckDetailNew",
  props: {
    printWidth: {
      type: Number,
      default: 210
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    data: {
      handler(newVal) {
        const { mainBill, detail, items } = newVal;
        this.detail = detail;
        this.mainBill = mainBill;
        this.items = items;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    tirePhotoPositions() {
      return [
        { key: "lf", label: "左前" },
        { key: "rf", label: "右前" },
        { key: "lb", label: "左后" },
        { key: "rb", label: "右后" }
      ];
    },
    displayItems() {
      const items = this.items || [];
      return items.filter((item) => item && item.itemName);
    },
    tirePhotoMap() {
      const map = { lf: [], rf: [], lb: [], rb: [] };
      const keyMap = [
        { keyword: "左前", key: "lf" },
        { keyword: "右前", key: "rf" },
        { keyword: "左后", key: "lb" },
        { keyword: "右后", key: "rb" }
      ];
      const items = this.displayItems || [];
      items.forEach((item) => {
        if (!item || !item.itemName || !item.itemName.includes("轮胎") || !item.photoes || !item.photoes.length) {
          return;
        }
        const hit = keyMap.find((it) => item.itemName.includes(it.keyword));
        if (hit) {
          map[hit.key].push(...item.photoes);
        }
      });
      return {
        lf: [...new Set(map.lf)],
        rf: [...new Set(map.rf)],
        lb: [...new Set(map.lb)],
        rb: [...new Set(map.rb)]
      };
    },
    hasTirePhotos() {
      return this.tireImgs.length > 0;
    },
    tireImgs() {
      const { lf, rf, lb, rb } = this.tirePhotoMap;
      return [...new Set([...(lf || []), ...(rf || []), ...(lb || []), ...(rb || [])])];
    },
    checkImgs() {
      const items = this.displayItems || [];
      const imgs = [];
      const tireSet = new Set(this.tireImgs);
      items.forEach((item) => {
        if (item.photoes) {
          item.photoes.forEach((img) => {
            if (!tireSet.has(img)) {
              imgs.push(img);
            }
          });
        }
      });
      return imgs.slice(0, 2);
    },
    checkRemark() {
      const items = this.displayItems || [];
      const remarkText = items
        .map((item) => item.remark || (item.itemName === "其他问题" ? item.desc : ""))
        .filter(Boolean)
        .join("、");
      if (remarkText) {
        return remarkText;
      }
      return items
        .map((item) => item.desc)
        .filter(Boolean)
        .join("、");
    },
    totalMilesText() {
      if (this.detail && this.detail.totalMiles !== undefined && this.detail.totalMiles !== null && this.detail.totalMiles !== "") {
        return `${this.detail.totalMiles} 公里`;
      }
      const milesItem = (this.displayItems || []).find((item) => item.itemName === "仪表盘里程");
      if (milesItem && milesItem.desc) {
        return milesItem.desc;
      }
      return "-";
    }
  },
  data() {
    return {
      detail: {},
      mainBill: {},
      items: []
    };
  },
  methods: {
    formatItemContent(item) {
      const parts = [];
      if (item.desc) {
        parts.push(item.desc);
      }
      if (item.remark) {
        parts.push(`备注：${item.remark}`);
      }
      return parts.join("；") || "-";
    }
  }
};
</script>

<style lang="less" scoped>
.check-detail {
  padding: 20px;

  #printArea {
    margin: 0 auto;
    padding: 20px;
    background: #fff;

    .title {
      text-align: center;
      margin-bottom: 20px;
      font-size: 20px;
    }

    .info-table {
      table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;

        td {
          border: 1px solid #000;
          padding: 8px;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
        }

        .content-cell {
          min-height: 60px;
          vertical-align: top;
        }

        .photo-cell {
          min-height: 120px;

          .photo-area {
            min-height: 100px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px dashed #ccc;
            margin-bottom: 10px;

            .photo-list {
              display: flex;
              flex-wrap: wrap;
              gap: 10px;

              .photo-item {
                img {
                  width: 200px;
                  object-fit: cover;
                  margin: 0 20px;
                }
              }
            }
          }

          .tire-photo-area {
            align-items: stretch;

            .tire-position-grid {
              width: 100%;
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 12px;

              .tire-position-item {
                border: 1px solid #dcdfe6;
                padding: 8px;

                .position-title {
                  margin-bottom: 8px;
                  font-weight: 600;
                }

                .photo-list {
                  min-height: 100px;
                  justify-content: center;
                }
              }
            }
          }
        }
      }
    }
  }

  @media print {
    padding: 0;
    background: #fff;
  }
}
</style>
